<template>
    <div class="flex flex-row">
        <div class="w-auto min-w-[45px] lg:min-w-[255px]">
            <div v-for="(item, key) in data" :key="item.id" @click="onClick(key)" class="p-1 lg:p-3 relative h-auto cursor-pointer">
                <slot name="header" :key="key" :data="item" :activeTabIndex="activeTabIndex"></slot>
            </div>
        </div>
        <div class="grow">
            <div v-for="(item, key) in data" :key="item.id">
                <slot v-if="activeTabIndex === key" name="item" :key="key" :data="item" :activeTabIndex="activeTabIndex"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: ['data', 'activeTab', 'firstOnLoad', 'activeColor', 'overlay', 'align'],

    emits: ['update:activeTab'],

    data: () => ({
        activeTabIndex: null
    }),

    mounted() {
        if (this.firstOnLoad) {
            this.activeTabIndex = 0;
            this.$emit('update:activeTab', this.activeTabIndex);
            // this.$emit('update:activeTab', _.first(this.activeTabIndex))
        }
    },

    methods: {
        onClick(key) {
            if (key != this.activeTabIndex) {
                this.$emit('update:activeTab', key), (this.activeTabIndex = key);
            } else {
                this.$emit('update:activeTab', 0), (this.activeTabIndex = 0);
            }
        }
    },

    watch: {
        activeColor: function () {
            return this.activeColor;
        }
    }
};
</script>

<style scoped>
.tab-indicator {
    background-color: v-bind(activeColor);
}
</style>
